import { useLatestQuery } from "../../../api/useLatestQuery";
import { candidateAPI } from "../../../api/candidate";
import { useCvPortalJobFull } from "../../jobView/useCvPortalJobFull";
import { useAdIrelTrel } from "../../jobView/useAdIrelTrel";
import { useWhoAmI } from "../../../user/useWhoAmI";

export function useApplyWithProfileFormData() {
  const { typeRelatedResolved, idRelatedResolved } = useAdIrelTrel({
    typeRelated: null,
    idRelated: null,
  });

  const { confirmedHasProfileInConcern } = useWhoAmI();

  let { data: isCandidateAttachedToCase, isFetched: isFetched1 } =
    useLatestQuery(
      [
        "candidateAPI.isCandidateAttachedToCase",
        idRelatedResolved,
        typeRelatedResolved,
      ],
      () =>
        candidateAPI.isCandidateAttachedToCase({
          idRelated: idRelatedResolved,
          typeRelated: typeRelatedResolved,
        }),
      {
        enabled: confirmedHasProfileInConcern,
      }
    );

  if (!confirmedHasProfileInConcern) {
    isFetched1 = true;
  }

  const { data: job, isFetched: isFetched2 } = useCvPortalJobFull({
    idRelated: idRelatedResolved,
    typeRelated: typeRelatedResolved,
  });

  const isFetched = isFetched1 && isFetched2;

  return {
    isFetched,
    job,

    isCandidateAttachedToCase: !!isCandidateAttachedToCase?.item,
    typeRelatedResolved,
    idRelatedResolved,
  };
}
